import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'

const resource = 'announcements'

export const requests = {
  read: async (id: number) => {
    return await axiosForGigbaseBiz.post<DataResponse<{ total: number }>>(
      mergeURL(resource, `read/${id.toString()}`),
    )
  },
}
